var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","md6":"","xl4":""}},[_c('div',{class:_vm.b()},[_c('div',{class:_vm.b('responsiver')},[_c('iframe',{attrs:{"src":_vm.url,"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_c('i',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.file.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }